import { getCloudFunctions, getFirestore, getFirestoreDeleteField } from '../../system/firebase';

import {
    getRaceList,
    getEmploymentTypeList,
    getSalaryRangeList,
    getEducationList,
    getOtherEducationList,
    getPayFrequencyList,
    getTeleworkList,
    getCurrencyList,
    getYearsOfExperienceOptions,
} from '../lovHelper';
import { convertFirebaseTimestampsToDate } from '../dateHelper';
import { convertEmployerTimestampsToDate } from '../employerHelper';
// import { ELASTIC_SEARCH_JWT_STATUS_CODE_USER_NOT_AUTHORIZED } from '../constants';
import { CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH } from '../../system/constants';
import {
    ELASTICSEARCH_JOB_TITLE_SKILL_SET_SUGGESTION_API_URL,
    ELASTICSEARCH_JS_NAME_OCCUPATION_SUGGESTION_API_URL,
    // ELASTICSEARCH_JWT_MAX_AGE,
    ELASTICSEARCH_LOCATION_SUGGESTION_API_URL,
    ELASTICSEARCH_OCCUPATION_SKILL_SET_SUGGESTION_API_URL,
    ELASTICSEARCH_SEARCH_EMP_JOB_API_URL,
    ELASTICSEARCH_SEARCH_EMP_PROFILE_API_URL,
    ELASTICSEARCH_SEARCH_JOB_API_URL,
    ELASTICSEARCH_SEARCH_JS_APPLIED_JOB_API_URL,
    ELASTICSEARCH_SEARCH_JS_PROFILE_API_URL,
    ELASTICSEARCH_SEARCH_JS_SAVED_JOB_API_URL,
} from '../elasticSearchHelper';

// import { isAfter, isValid as isValidDate, addMinutes } from 'date-fns';

import _get from 'lodash/get';
// import _map from 'lodash/map';
import _keys from 'lodash/keys';
import _toLower from 'lodash/toLower';
import _sortBy from 'lodash/sortBy';

export const loadSys = setSys => {
    const db = getFirestore();

    const docRef = db.collection('app').doc('sys');

    return docRef.onSnapshot(doc => {
        if (doc.exists) {
            let data = doc.data();
            setSys(data);
        }
    });
};

/**
 *
 * @param {*} docId Either employerId or userId (job seeker or member)
 * @param {*} setAlertData
 * @returns
 */
export const loadAlertsById = ({ docId, setData }) => {
    // console.log('%c@@@@ loadAlertsById docId=', 'background: #222; color: #bada55', loadAlertsById);

    const db = getFirestore();

    const alertsRef = db.collection('userAlerts').doc(docId);

    return alertsRef.onSnapshot(docSnapshot => {
        const alertData = docSnapshot.data();
        // console.log('%c@@@@ loadAlertsById alertData=', 'background: #222; color: #bada55', alertData);
        // setAlertData(docSnapshot.data());
        setData(alertData);

        try {
            // Now that the alerts have been set, reset the alert flags in the database to false.
            db.runTransaction(async transaction => {
                transaction.set(
                    alertsRef,
                    {
                        newJobApplicationAlert: getFirestoreDeleteField(),
                        newMessageAlert: getFirestoreDeleteField(),
                        pendingInterviewAlert: getFirestoreDeleteField(),
                        rescheduleInterviewAlert: getFirestoreDeleteField(),
                        confirmInterviewAlert: getFirestoreDeleteField(),
                        declineInterviewAlert: getFirestoreDeleteField(),
                    },
                    { merge: true },
                );

                console.log('loadAlertsById Transaction successfully committed!');
            });
        } catch (error) {
            console.log('loadAlertsById Transaction failed: ', error);
        }
    });
};

export const loadLovs = setLovs => {
    const db = getFirestore();
    let lovs = {};

    const lovsQuery = db.collection('lovs');
    return lovsQuery.onSnapshot(querySnapshot => {
        querySnapshot.forEach(doc => {
            const docId = doc.id;
            const data = doc.data();
            lovs[docId] = _sortBy(_get(data, 'list', []));
        });

        setLovs(prev => ({
            ...prev,
            ...lovs,
            raceLov: getRaceList(),
            employmentTypeLov: getEmploymentTypeList(),
            salaryRangeLov: getSalaryRangeList(),
            educationLov: getEducationList(),
            otherEducationLov: getOtherEducationList(),
            payFrequencyLov: getPayFrequencyList(),
            teleworkLov: getTeleworkList(),
            currencyLov: getCurrencyList(),
            yearsOfExperienceLov: getYearsOfExperienceOptions(),
        }));
    });

    // const lovsRef = db.collection('app').doc('lovs');

    // return lovsRef.onSnapshot(doc => {
    //     if (doc.exists) {
    //         let data = doc.data();

    //         setLovs({
    //             countryLov: _sortBy(_get(data, 'countryList', [])),
    //             occupationLov: _sortBy(_get(data, 'occupationList', [])),
    //             skillsetLov: _sortBy(_get(data, 'skillsetList', [])),
    //             genderLov: _get(data, 'genderList', []),
    //             industryLov: _sortBy(_get(data, 'industryList', [])),
    //             raceLov: getRaceList(),
    //             employmentTypeLov: getEmploymentTypeList(),
    //             salaryRangeLov: getSalaryRangeList(),
    //             educationLov: getEducationList(),
    //             otherEducationLov: getOtherEducationList(),
    //             payFrequencyLov: getPayFrequencyList(),
    //             teleworkLov: getTeleworkList(),
    //             currencyLov: getCurrencyList(),
    //             unsubscribeReasonLov: _get(data, 'unsubscribeReasonList', []),
    //         });
    //     }
    // });
};

export const loadLovsUnauthenticated = setLovs => {
    const db = getFirestore();
    let lovs = {};

    const countryDocRef = db.collection('lovs').doc('countryLov');
    return countryDocRef.onSnapshot(doc => {
        // const docId = doc.id;
        const data = doc.data();
        lovs['countryLov'] = _sortBy(_get(data, 'list', []));

        setLovs(prev => ({
            ...prev,
            ...lovs,
            payFrequencyLov: getPayFrequencyList(),
        }));
    });
};

export const loadStateListByCountry = async countryName => {
    const db = getFirestore();
    let stateLov = [];
    const cityLov = [];

    const docRef = db.collection('countries').doc(_toLower(countryName));

    const doc = await docRef.get();
    if (doc.exists) {
        const data = doc.data();
        stateLov = _get(data, 'stateList', []);
    }

    return { stateLov, cityLov };
};

export const loadCityListByCountryState = async (countryName, stateName) => {
    const db = getFirestore();
    let cityLov = [];

    const docRef = db.collection('countries').doc(_toLower(countryName)).collection('states').doc(_toLower(stateName));

    const doc = await docRef.get();
    if (doc.exists) {
        const data = doc.data();
        cityLov = _get(data, 'cityList', []);
    }

    return { cityLov };
};

export const loadUserData = ({ userId, setUser, callback }) => {
    const db = getFirestore();
    const userRef = db.collection('users').doc(userId);

    return userRef.onSnapshot(docSnapshot => {
        const data = docSnapshot.data();
        const appliedJobs = _get(data, 'appliedJobs');
        const jobIdList = _keys(appliedJobs);
        setUser({ ...data, appliedJobs: convertFirebaseTimestampsToDate(appliedJobs, jobIdList) });
        if (callback) callback({ userDocExist: docSnapshot.exists, userData: data });
    });
};

export const loadEmployerData = ({ setEmployer, employerId }) => {
    const db = getFirestore();
    const docRef = db.collection('employers').doc(employerId);

    return docRef.onSnapshot(snapshot => {
        const data = convertEmployerTimestampsToDate(snapshot.data());
        setEmployer({ ...data, uid: employerId });
    });
};

/**
 * @deprecated
 * @returns
 */
export const getElasticSearchJwt = async () => {
    // const functions = getCloudFunctions();
    // const getElasticSearchJwt = functions.httpsCallable(CLOUD_FUNCTION_NAME_GET_ELASTICSEARCH_JWT);
    // try {
    //     const elasticSearchJwtData = await getElasticSearchJwt();
    //     const status = _get(elasticSearchJwtData, 'data.status');
    //     if (status === ELASTIC_SEARCH_JWT_STATUS_CODE_USER_NOT_AUTHORIZED) {
    //         return null;
    //     } else {
    //         return _get(elasticSearchJwtData, 'data');
    //     }
    // } catch (error) {
    //     console.log('Failed to retrieve token for searches.', error);
    // }
};

/**
 * @deprecated
 * @param {*} token
 * @returns
 */
export const checkEsToken = async (/* token */) => {
    // let isNeedNewToken = false;
    // const startDtMs = _get(token, 'startDtMs');

    // // if no token or no startDtMs, get a new token
    // isNeedNewToken = !token || !startDtMs;

    // // or if token has expired
    // if (!isNeedNewToken && isValidDate(startDtMs)) {
    //     if (isAfter(startDtMs, addMinutes(new Date(), ELASTICSEARCH_JWT_MAX_AGE))) {
    //         isNeedNewToken = true;
    //     }
    // }

    // // get new token
    // if (isNeedNewToken) {
    //     const newToken = await getElasticSearchJwt();
    //     return { ...newToken, isNew: true };
    // } else {
    //     // token is still good
    //     return Promise.resolve(token);
    // }

    return Promise.resolve({});
};

//==========================================================================
//==========================================================================
//==========================================================================
//
// Changed all ElasticSearch calls to call Cloud Function instead of
//   directly calling ES. -el 20221111
//
//==========================================================================
//==========================================================================
//==========================================================================
//==========================================================================

// export const getElasticSearchSyncPostFetch = ({ url, type, values = [], token }) => {
//     return fetch(url, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//             type,
//             values,
//         }),
//     });
// };

// export const getElasticSearchSuggestionPostFetch = async ({ url, type, queryObject = {}, token }) => {
//     const res = await fetch(url, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ type, queryObject }),
//     });
//     if (res.status === 200) {
//         return res.json();
//     } else {
//         throw new Error(`Failed to get suggestion for '${type}'. HTTP status: ${res.status}`);
//     }
// };

// export const getElasticSearchSearchPostFetch = ({ url, queryObject = {}, token }) => {
//     return fetch(url, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(queryObject),
//     });
// };

export const getElasticSearchSyncPostFetch = async ({ url, type, values = [] }) => {
    const functions = getCloudFunctions();
    const callElasticSearch = functions.httpsCallable(CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH);
    try {
        await callElasticSearch({ url, type, values, callType: 'SYNC' });

        //TODO Refactor all callers
        // For now, return true because the callers don't expect anything
        return true;
        ////
    } catch (error) {
        console.log('getElasticSearchSyncPostFetch Failed to call ElasticSearch gateway for searches.', error);
        // alert(`getElasticSearchSyncPostFetch Failed to call ElasticSearch gateway for searches. ${error}`);
    }
};

export const getElasticSearchSuggestionPostFetch = async ({ url, type, queryObject = {} }) => {
    const functions = getCloudFunctions();
    const callElasticSearch = functions.httpsCallable(CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH);
    try {
        const resp = await callElasticSearch({ url, type, queryObject, callType: 'SUGGESTION' });

        //TODO Refactor all callers
        // For now, return 'data' portion because that's what the callers expect
        return resp?.data;
        ////
    } catch (error) {
        console.log('getElasticSearchSuggestionPostFetch Failed to call ElasticSearch gateway for searches.', error);
        // alert(`getElasticSearchSuggestionPostFetch Failed to call ElasticSearch gateway for searches. ${error}`);
    }
};

export const getElasticSearchSearchPostFetch = async ({ url, queryObject = {} }) => {
    const functions = getCloudFunctions();
    const callElasticSearch = functions.httpsCallable(CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH);
    try {
        const resp = await callElasticSearch({ url, queryObject, callType: 'SEARCH' });

        //TODO Refactor all callers
        // For now, return made-up HTTP response object because that's what the callers expect
        return { json: () => resp?.data, status: 200 };
        ////
    } catch (error) {
        console.log('getElasticSearchSearchPostFetch Failed to call ElasticSearch gateway for searches.', error);
        // alert(`getElasticSearchSearchPostFetch Failed to call ElasticSearch gateway for searches. ${error}`);
    }
};

//==========================================================================
// END OF: Changed all ElasticSearch calls to call Cloud Function instead of
//   directly calling ES. -el 20221111
//==========================================================================

export const elasticSearchJobSearchPostFetch = async ({ queryObject, token }) => {
    const res = await getElasticSearchSearchPostFetch({ url: ELASTICSEARCH_SEARCH_JOB_API_URL, queryObject, token });
    const status = _get(res, 'status');
    if (status === 200) {
        return res.json();
    } else {
        return { success: false, error: `HTTP ${status} error` };
    }
};

export const elasticSearchJsProfileSearchPostFetch = async ({ queryObject, token }) => {
    const res = await getElasticSearchSearchPostFetch({ url: ELASTICSEARCH_SEARCH_JS_PROFILE_API_URL, queryObject, token });
    const status = _get(res, 'status');
    if (status === 200) {
        return res.json();
    } else {
        return { success: false, error: `HTTP ${status} error` };
    }
};

export const elasticSearchJobTitleSkillSetSuggestionSearchPostFetch = async ({ queryObject, token }) => {
    const res = await getElasticSearchSearchPostFetch({ url: ELASTICSEARCH_JOB_TITLE_SKILL_SET_SUGGESTION_API_URL, queryObject, token });
    const status = _get(res, 'status');
    if (status === 200) {
        return res.json();
    } else {
        return { success: false, error: `HTTP ${status} error` };
    }
};

export const elasticSearchOccupationSkillSetSuggestionSearchPostFetch = async ({ queryObject, token }) => {
    const res = await getElasticSearchSearchPostFetch({ url: ELASTICSEARCH_OCCUPATION_SKILL_SET_SUGGESTION_API_URL, queryObject, token });
    const status = _get(res, 'status');
    if (status === 200) {
        return res.json();
    } else {
        return { success: false, error: `HTTP ${status} error` };
    }
};

// export const getElasticSearchLocationSuggestionPostFetch = async ({ queryObject = {}, token }) => {
//     const res = await fetch(ELASTICSEARCH_LOCATION_SUGGESTION_API_URL, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(queryObject),
//     });
//     if (res.status === 200) {
//         return res.json();
//     } else {
//         throw new Error(`Failed to get location suggestion. HTTP status: ${res.status}`);
//     }
// };

// export const getElasticSearchJsNameOccupationSuggestionPostFetch = async ({ queryObject = {}, token }) => {
//     const res = await fetch(ELASTICSEARCH_JS_NAME_OCCUPATION_SUGGESTION_API_URL, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(queryObject),
//     });
//     if (res.status === 200) {
//         return res.json();
//     } else {
//         throw new Error(`Failed to get js-profile-occupation suggestion. HTTP status: ${res.status}`);
//     }
// };

export const getElasticSearchLocationSuggestionPostFetch = async ({ queryObject = {} }) => {
    const functions = getCloudFunctions();
    const callElasticSearch = functions.httpsCallable(CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH);
    try {
        const resp = await callElasticSearch({ url: ELASTICSEARCH_LOCATION_SUGGESTION_API_URL, queryObject, callType: 'SEARCH' });

        //TODO Refactor all callers
        // For now, return 'data' portion because that's what the callers expect
        return resp?.data;
        ////
    } catch (error) {
        console.log('getElasticSearchLocationSuggestionPostFetch Failed to call ElasticSearch gateway for searches.', error);
        // alert(`getElasticSearchLocationSuggestionPostFetch Failed to call ElasticSearch gateway for searches. ${error}`);
    }
};

export const getElasticSearchJsNameOccupationSuggestionPostFetch = async ({ queryObject = {} }) => {
    const functions = getCloudFunctions();
    const callElasticSearch = functions.httpsCallable(CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH);
    try {
        const resp = await callElasticSearch({ url: ELASTICSEARCH_JS_NAME_OCCUPATION_SUGGESTION_API_URL, queryObject, callType: 'SEARCH' });

        //TODO Refactor all callers
        // For now, return 'data' portion because that's what the callers expect
        return resp?.data;
        ////
    } catch (error) {
        console.log('getElasticSearchJsNameOccupationSuggestionPostFetch Failed to call ElasticSearch gateway for searches.', error);
        // alert(`getElasticSearchJsNameOccupationSuggestionPostFetch Failed to call ElasticSearch gateway for searches. ${error}`);
    }
};

export const elasticSearchEmployerSearchPostFetch = async ({ queryObject, token }) => {
    const res = await getElasticSearchSearchPostFetch({ url: ELASTICSEARCH_SEARCH_EMP_PROFILE_API_URL, queryObject, token });
    const status = _get(res, 'status');
    if (status === 200) {
        return res.json();
    } else {
        return { success: false, error: `HTTP ${status} error` };
    }
};

export const elasticSearchJsSavedJobSearchPostFetch = async ({ queryObject, token }) => {
    const res = await getElasticSearchSearchPostFetch({ url: ELASTICSEARCH_SEARCH_JS_SAVED_JOB_API_URL, queryObject, token });
    const status = _get(res, 'status');
    if (status === 200) {
        return res.json();
    } else {
        return { success: false, error: `HTTP ${status} error` };
    }
};

export const elasticSearchJsAppliedJobSearchPostFetch = async ({ queryObject, token }) => {
    const res = await getElasticSearchSearchPostFetch({ url: ELASTICSEARCH_SEARCH_JS_APPLIED_JOB_API_URL, queryObject, token });
    const status = _get(res, 'status');
    if (status === 200) {
        return res.json();
    } else {
        return { success: false, error: `HTTP ${status} error` };
    }
};

export const elasticSearchEmpJobSearchPostFetch = async ({ queryObject, token }) => {
    const res = await getElasticSearchSearchPostFetch({ url: ELASTICSEARCH_SEARCH_EMP_JOB_API_URL, queryObject, token });
    const status = _get(res, 'status');
    // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> here');
    if (status === 200) {
        // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> res', res.json());
        return res.json();
    } else {
        return { success: false, error: `HTTP ${status} error` };
    }
};
